import { BMEventsType } from '../../../types';
import { customTimings } from './custom';
import { ssrTimings } from './ssr';
export const appTimings = (config, data, globalConfig) => {
  const explicitTimings = config.type === BMEventsType.PAGE_LOAD && data.explicitTimings || null;
  const timings = customTimings(config, data);
  const ssr = config.type === BMEventsType.PAGE_LOAD && data.isInitial ? ssrTimings(config, data, globalConfig) : null;
  const timingsApp = (explicitTimings || timings || ssr) && { ...explicitTimings,
    ...timings,
    ...ssr
  };

  if (!timingsApp) {
    return null;
  }

  return {
    'timings:app': timingsApp
  };
};